import React from "react"

import NotificationContainer from "components/NotificationContainer"

import UpdateTailoredAssignmentUserModal from "./Modal"

type ResetTailoredAssignmentUserProps = {
  userId: string
  tailoredAssignmentId: string
  tailoredAssignmentUserState: "completed" | "in_progress"
}

const ResetTailoredAssignmentUser: React.FC<
  ResetTailoredAssignmentUserProps
> = ({ userId, tailoredAssignmentId, tailoredAssignmentUserState }) => {
  return (
    <>
      <NotificationContainer />
      <UpdateTailoredAssignmentUserModal
        userId={userId}
        tailoredAssignmentId={tailoredAssignmentId}
        tailoredAssignmentUserState={tailoredAssignmentUserState}
      />
    </>
  )
}

export default ResetTailoredAssignmentUser
